/**
 * Created by sumudu on 11/25/16.
 */
(function () {
    angular.module('trainingPrograms')
        .component('trainingInfo', {
            templateUrl: 'training-programs/components/training-assign-info-component.tpl.html',
            controller: function (TrainingAssignCrewModel,TrainingAssignCrewLogic) {
                var vm = this;
                vm.selectedTrainig = null;

                vm.$onInit = function () {
                    TrainingAssignCrewModel.selectedTraining.subscribe(function (selectedTraining) {
                        vm.selectedTrainig = TrainingAssignCrewLogic.formatTrainingStartDate(selectedTraining);
                    })
                };
            },
            bindings: {}
        });
})();
